/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 17th February 2019
 *
 *  Portal - Login View: Password Reset
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

// Material UI
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import EmailInput from 'components/InputFields/Email';

class PasswordReset extends React.Component {
  render() {
    const { classes } = this.props;

    const { email, handleEmailChange, isLoading, passwordReset } = this.props.loginStore;

    const isInvalid = email === '';

    return (
      <form autoComplete="on" action="" onSubmit={passwordReset}>
        <Grid container direction="column">
          <Grid item className={classes.formGridItem}>
            <Typography variant="h5" color="primary">
              Reset your password
            </Typography>
            <Grid item xl={7} lg={8} sm={10} xs={12}>
              <Typography variant="body2" className={classes.resetSubTitle}>
                Enter your registered email address below and we'll send you a link to reset your
                password.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <EmailInput
              id="email"
              autoComplete="on"
              disabled={isLoading}
              InputProps={{
                required: true,
                value: email,
                onChange: handleEmailChange,
                fullWidth: true,
                margin: 'dense',
                className: classes.formInput,
              }}
            />
          </Grid>
        </Grid>
        <Grid container justify="center" direction="column">
          <Grid item className={classes.buttonWrapper}>
            <Button
              variant="contained"
              disabled={isInvalid || isLoading}
              type="submit"
              color="primary"
              className={classes.formButton}
              style={{ width: '275px' }}
            >
              Reset Password
            </Button>
            {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Grid>
          <Grid item>
            <Typography>Already have an account?</Typography>
          </Grid>
          <Grid item>
            <Button component={Link} to="/login" color="primary">
              Sign In
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  }
}

PasswordReset.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const styles = theme => ({
  buttonWrapper: {
    position: 'relative',
  },
  formGridItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
    textAlign: 'center',
  },
  formInput: {
    minWidth: '265px',
    marginBottom: '8px',
    fontSize: '12pt',
  },
  formButton: {
    marginTop: '25px',
    marginBottom: '15px',
    fontSize: '12pt',
  },
  buttonProgress: {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -8,
    marginLeft: -15,
  },
  iconButton: {
    color: theme.palette.type === 'light' ? 'rgb(128, 128, 128)' : theme.palette.common.white,
    padding: '0',
  },
  resetSubTitle: {
    color: theme.palette.text.primary,
    //width: '65%',
    marginTop: '20px',
    paddingRight: '10px',
    paddingLeft: '10px',
  },
  grow: {
    flexGrow: 1,
    width: '100%',
  },
  navLink: {
    '&:link, &:visited': {
      textDecoration: 'none',
      color: theme.palette.text.primary,
    },
    '&:hover': {
      color: theme.palette.primary,
    },
    '&:active': {
      color: theme.palette.primary,
    },
  },
});

export default withStyles(styles, { withTheme: true })(
  inject('loginStore')(observer(PasswordReset))
);
